import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faLinkHorizontal } from '@fortawesome/pro-light-svg-icons';

export type ProLightLinkHorizontalProps = IconComponentProps;

export const ProLightLinkHorizontal = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightLinkHorizontalProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faLinkHorizontal}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faLinkHorizontal}
    />
  );
};

ProLightLinkHorizontal.displayName = 'ProLightLinkHorizontal';
